import React, { Children } from 'react';
export function PrivacyPage() {
  return <main className="w-full" data-id="element-800">
      {/* Hero Section */}
      <section className="w-full bg-gradient-to-br from-[#07493a] to-[#1a6b55] py-20 px-4" data-id="element-801">
        <div className="max-w-7xl mx-auto text-center" data-id="element-802">
          <h1 className="text-4xl md:text-6xl font-serif font-bold text-white mb-6" data-id="element-803">
            Privacy Policy
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-804">
            Last updated: February 24, 2026
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="w-full bg-cream py-20 px-4" data-id="element-805">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8 md:p-12" data-id="element-806">
          <div className="prose prose-lg max-w-none" data-id="element-807">
            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-4" data-id="element-808">
              1. Introduction
            </h2>
            <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-809">
              EquityRich.ca ("we," "our," or "us") is committed to protecting
              your privacy. This Privacy Policy explains how we collect, use,
              disclose, and safeguard your information when you visit our
              website or use our services.
            </p>

            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-4" data-id="element-810">
              2. Information We Collect
            </h2>
            <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-811">
              We collect information that you provide directly to us, including:
            </p>
            <ul className="list-disc pl-6 text-gray-700 mb-6 space-y-2" data-id="element-812">
              <li data-id="element-813">
                Personal identification information (name, email address, phone
                number)
              </li>
              <li data-id="element-814">Property information (address, value, ownership status)</li>
              <li data-id="element-815">Financial information necessary for mortgage assessment</li>
              <li data-id="element-816">Communication preferences and inquiry details</li>
            </ul>

            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-4" data-id="element-817">
              3. How We Use Your Information
            </h2>
            <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-818">
              We use the information we collect to:
            </p>
            <ul className="list-disc pl-6 text-gray-700 mb-6 space-y-2" data-id="element-819">
              <li data-id="element-820">
                Process your mortgage application and provide our services
              </li>
              <li data-id="element-821">Communicate with you about your inquiry and our services</li>
              <li data-id="element-822">Assess your eligibility for mortgage products</li>
              <li data-id="element-823">Comply with legal and regulatory requirements</li>
              <li data-id="element-824">Improve our website and services</li>
              <li data-id="element-825">Send you marketing communications (with your consent)</li>
            </ul>

            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-4" data-id="element-826">
              4. Information Sharing and Disclosure
            </h2>
            <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-827">
              We may share your information with trusted third parties,
              including mortgage lenders, brokers, and service providers who
              assist us in operating our business. We require these parties to
              protect your information and use it only for the purposes we
              specify. We do not sell your personal information to third
              parties.
            </p>

            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-4" data-id="element-828">
              5. Data Security
            </h2>
            <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-829">
              We implement appropriate technical and organizational measures to
              protect your personal information against unauthorized access,
              alteration, disclosure, or destruction. However, no method of
              transmission over the internet or electronic storage is 100%
              secure, and we cannot guarantee absolute security.
            </p>

            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-4" data-id="element-830">
              6. Your Rights and Choices
            </h2>
            <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-831">
              You have the right to:
            </p>
            <ul className="list-disc pl-6 text-gray-700 mb-6 space-y-2" data-id="element-832">
              <li data-id="element-833">Access and receive a copy of your personal information</li>
              <li data-id="element-834">
                Request correction of inaccurate or incomplete information
              </li>
              <li data-id="element-835">
                Request deletion of your personal information (subject to legal
                requirements)
              </li>
              <li data-id="element-836">Opt-out of marketing communications</li>
              <li data-id="element-837">Withdraw consent for data processing (where applicable)</li>
            </ul>

            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-4" data-id="element-838">
              7. Cookies and Tracking Technologies
            </h2>
            <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-839">
              We use cookies and similar tracking technologies to enhance your
              experience on our website, analyze usage patterns, and deliver
              personalized content. You can control cookie settings through your
              browser preferences.
            </p>

            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-4" data-id="element-840">
              8. Third-Party Links
            </h2>
            <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-841">
              Our website may contain links to third-party websites. We are not
              responsible for the privacy practices or content of these external
              sites. We encourage you to review the privacy policies of any
              third-party sites you visit.
            </p>

            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-4" data-id="element-842">
              9. Children's Privacy
            </h2>
            <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-843">
              Our services are not directed to individuals under the age of 18.
              We do not knowingly collect personal information from children. If
              you believe we have collected information from a child, please
              contact us immediately.
            </p>

            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-4" data-id="element-844">
              10. Changes to This Privacy Policy
            </h2>
            <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-845">
              We may update this Privacy Policy from time to time. We will
              notify you of any changes by posting the new Privacy Policy on
              this page and updating the "Last updated" date. Your continued use
              of our services after any changes constitutes your acceptance of
              the updated policy.
            </p>

            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-4" data-id="element-846">
              11. Contact Us
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-847">
              If you have questions or concerns about this Privacy Policy or our
              data practices, please contact us at:
            </p>
            <p className="text-gray-700 mt-4" data-id="element-848">
              <strong data-id="element-849">EquityRich.ca</strong>
              <br data-id="element-850" />
              18 Wynford Dr, Suite 307
              <br data-id="element-851" />
              Toronto, ON, M3C 3S2
              <br data-id="element-852" />
              Email: info@equityrich.ca
              <br data-id="element-853" />
              Phone: +1-647-667-9957
            </p>
          </div>
        </div>
      </section>
    </main>;
}